export function contactResetBaseStateRequest() {
  return {
    type: '@contacts/RESET_BASE_STATE_REQUEST'
  }
}

export function contactResetBaseStateSuccess() {
  return {
    type: '@contacts/RESET_BASE_STATE_SUCCESS'
  }
}

export function contactResetBaseStateFailure() {
  return {
    type: '@contacts/RESET_BASE_STATE_FAILURE'
  }
}
